<!--
 * @Author: your name
 * @Date: 2021-01-06 17:09:21
 * @LastEditTime: 2021-01-07 22:05:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\problem\index.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link to="/home">
          服务大厅
        </router-link>
        &gt; 常见问题
      </div>
    </div>
    <div class="row">
      <div class="card">
        <div style="width: 70px">
          <img src="@/assets/student.jpg"/>
        </div>
        <div class="cardRight">
          <div class="rightTop">
            <b>学生/家长</b>
            <router-link
                :to="{ path: '/problem/list', query: { type: 'student' } }"
            >更多》
            </router-link
            >
          </div>
          <div class="rightBody">
            <div
                v-for="(item, index) in problemList.student"
                :key="index"
                class="rightBodyItems"
            >
              <div
                  style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                "
              >
                <img
                    style="margin-right: 5px"
                    src="@/assets/arrow.jpg"
                    alt=""
                />
                <span @click="go('problem/info',  item)" class="name">{{ item.name }}</span>
              </div>
              <div>{{ item.gmtCreate }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div style="width: 70px">
          <img src="@/assets/teacher.jpg"/>
        </div>
        <div class="cardRight">
          <div class="rightTop">
            <b>教师</b>
            <router-link
                :to="{ path: '/problem/list', query: { type: 'teacher' } }"
            >更多》
            </router-link
            >
          </div>
          <div class="rightBody">
            <div
                v-for="(item, index) in problemList.teacher"
                :key="index"
                class="rightBodyItems"
            >
              <div
                  style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                "
              >
                <img
                    style="margin-right: 5px"
                    src="@/assets/arrow.jpg"
                    alt=""
                />
                <span @click="go('problem/info',  item)" class="name">{{ item.name }}</span>
              </div>
              <div>{{ item.gmtCreate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="card">
        <div style="width: 70px">
          <img src="@/assets/teacher.jpg"/>
        </div>
        <div class="cardRight">
          <div class="rightTop">
            <b>教育机构</b>
            <router-link
                :to="{ path: '/problem/list', query: { type: 'educational' } }"
            >更多》
            </router-link
            >
          </div>
          <div class="rightBody">
            <div
                v-for="(item, index) in problemList.educational"
                :key="index"
                class="rightBodyItems"
            >
              <div
                  style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                "
              >
                <img
                    style="margin-right: 5px"
                    src="@/assets/arrow.jpg"
                    alt=""
                />
                <span @click="go('problem/info',  item)" class="name">{{ item.name }}</span>
              </div>
              <div>{{ item.gmtCreate }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div style="width: 70px">
          <img src="@/assets/teacher.jpg"/>
        </div>
        <div class="cardRight">
          <div class="rightTop">
            <b>社会公众</b>
            <router-link
                :to="{ path: '/problem/list', query: { type: 'common' } }"
            >更多》
            </router-link
            >
          </div>
          <div class="rightBody">
            <div
                v-for="(item, index) in problemList.common"
                :key="index"
                class="rightBodyItems"
            >
              <div
                  style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                "
              >
                <img
                    style="margin-right: 5px"
                    src="@/assets/arrow.jpg"
                    alt=""
                />
                <span @click="go('problem/info',  item)" class="name">{{ item.name }}</span>
              </div>
              <div>{{ item.gmtCreate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAction, postAction} from "@/api/manage";

export default {
  data() {
    return {
      problemList: [],
      userId: sessionStorage.getItem('userId'),
      userName: sessionStorage.getItem('userName'),
      sign: sessionStorage.getItem('sign'),
    };
  },
  created() {
    this.getList();
  },
  methods: {
    go(url, item) {
      getAction('/user/appeal/appeal/getDetails', {id: item.id}).then((data) => {
        if (data.code === 0) {
          this.$router.push({
            path: url,
            query: {
              record: encodeURIComponent(JSON.stringify(data.data))
            }
          })
        } else {
          this.$message.error(data.message)
        }
      })

    },
    getList() {
      postAction("/user/appeal/appeal/problem", {
        pageNum: 1,
        pageSize: 10,
      }).then((data) => {
        this.problemList = data.data;
      });
    },
  },
};
</script>

<style scoped>
.itemsList {
  margin-top: 20px;
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.row {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card {
  width: 49%;
  height: 400px;
  overflow: hidden;
  border: 1px solid #e6e6e6;
  padding: 5px 10px;
  display: flex;
  align-items: flex-start;
}

.cardRight {
  width: calc(100% - 70px);
  font-size: 16px;
  color: black;
}

.rightTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgb(243, 207, 103);
  line-height: 40px;
}

.rightBodyItems {
  display: flex;
  align-items: center;
  line-height: 35px;
  font-size: 14px;
  justify-content: space-between;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 350px;
}

.name:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
